var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"BannerWrap",staticClass:"Banner"},[_c('img',{staticClass:"pc_banner",attrs:{"src":require("../assets/img/knowledgeService.jpg"),"alt":"banner"}}),_vm._v(" "),_c('img',{staticClass:"mobile_banner",attrs:{"src":require("../assets/img/banner_mobile.jpg"),"alt":"banner"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ec2ba5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue
// module id = null
// module chunks = 